module.exports = __webpack_public_path__ + "img/user.24d66af2.png";